export default {
  data: {
    bgColor: '#F5F5F5',
    cPrimary: '#184c78',
    cSecondary: '#FDC00F',
    cAccent: '#101C30',
    screenW: 0,
    screenH: 0,
    scrollY: 0,
  },
  methods: {
    pushRoute (route) {
      let self = this
      self.$router.push(route)
      .catch(err => {
        console.log(err)
      })
    },
    scrollTo(to, duration, start = 0) {
      let change = to - start,
        currentTime = 0,
        increment = 20,
        easeInOutQuad = function (t, b, c, d) {
          t /= d/2
          if (t < 1) {
            return c/2*t*t + b
          }
          t--
          return -c/2 * (t*(t-2) - 1) + b
        }
      let animateScroll = function () {
        currentTime += increment
        let val = parseInt(easeInOutQuad(currentTime, start, change, duration))
        window.scrollTo(0, val)
        // document.body.scrollTop = val
        // document.getElementById('app').scrollTop = val
        if(currentTime < duration) {
            setTimeout(animateScroll, increment)
        }
      }
      animateScroll()
    },
    delay (callback, time = 1000) {
      setTimeout(() => {
        callback()
      }, time)
    }
  }
}